import { Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';

const SECTIONS = [
  { emoji: '🚀', key: 'GettingStarted' },
  { emoji: '🛡️', key: 'StayingProtected' },
  { emoji: '💪', key: 'LookingAfterHealth' },
] as const;

export const LabPurposePage = () => {
  const { t } = useTranslation('labs', { keyPrefix: 'LabPurposePage' });

  return (
    <div className="space-y-xxl pt-s">
      <div className="space-y-xs">
        <Text size="headingM" as="h1">
          {t('Title')}
        </Text>
        <Text size="bodyL">{t('Description')}</Text>
      </div>
      <div className="space-y-xl">
        {SECTIONS.map(({ emoji, key }) => (
          <div key={key} className="flex flex-col [--emoji-circle:48px]">
            <div className="flex flex-row gap-m items-center">
              <span
                className="inline-flex items-center justify-center w-[var(--emoji-circle)] h-[var(--emoji-circle)] shrink-0 rounded-full bg-positive-subtle border border-default text-xl"
                aria-hidden="true"
              >
                {emoji}
              </span>
              <Text size="headingXS" as="h2">
                {t(`${key}.Title`)}
              </Text>
            </div>
            <div className="ml-[calc(var(--emoji-circle)+var(--size-m))]">
              <Text size="bodyL" color="contentSubdued">
                {t(`${key}.Description`)}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
